import { parseFlagValue, getFlagsEnvironmentMap } from 'Utils/features';
import AbstractFeatureFlagProvider from './AbstractFeatureFlagProvider';

export default class EnvFeatureFlagProvider extends AbstractFeatureFlagProvider {
  constructor(priority) {
    super('ENV_FF', priority);
  }

  async getFeatureFlags() {
    const envFlagsMap = getFlagsEnvironmentMap();
    Object
      .entries(envFlagsMap)
      .forEach(([name, prefixName]) => prefixName in process.env && this.features.set(
        name,
        parseFlagValue(process.env[prefixName]),
      ));
  }
}
